export enum ClientSurveysTableHeaders {
  Questions = 'Questions',
  Category = 'Category',
  SentBy = 'Sent by',
  SendDate = 'Send date',
  Progress = 'Progress',
}
